import { render, staticRenderFns } from "./provideHeKangServePeople.vue?vue&type=template&id=2d253f80&scoped=true&"
import script from "./provideHeKangServePeople.vue?vue&type=script&lang=js&"
export * from "./provideHeKangServePeople.vue?vue&type=script&lang=js&"
import style0 from "./provideHeKangServePeople.vue?vue&type=style&index=0&id=2d253f80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d253f80",
  null
  
)

export default component.exports